import React from 'react';
import { isWorkerAvailableForShift } from '../../utils/weeklyAvailability';

export default function WeeklyAvailabilityBadge({ worker, shift, facility }) {
  // A malformed explicit timezone remains unknown; never silently use device time.
  const timeZone = shift?.timeZone ?? shift?.timezone ?? facility?.timeZone ?? facility?.timezone;
  const result = isWorkerAvailableForShift(worker, shift, timeZone);
  const quick = { off_today: 'Off Today', vacation: 'Vacation', sick: 'Sick' }[String(worker?.availabilityStatus || '').toLowerCase()];
  const label = result === true ? 'Available for this shift' : result === false ? 'Unavailable for this shift' : 'Availability unknown';
  const tone = quick || result === false ? ['#fff4e5','#865517'] : result === true ? ['#edf7ef','#27633b'] : ['#f1f5f9','#526173'];
  return <span style={{ display:'flex', flexWrap:'wrap', gap:5, marginTop:6, fontSize:11, fontWeight:500 }}>
    <span title="Recurring weekly preference only. Existing assignment checks still apply." style={{ background:tone[0], color:tone[1], padding:'3px 7px', borderRadius:8 }}>Weekly schedule: {label}</span>
    {quick && <span style={{ background:'#fff0e5', color:'#893c18', padding:'3px 7px', borderRadius:8, fontWeight:650 }}>Quick Status: {quick}</span>}
  </span>;
}
